const func = $target => {
    var id = $target.data('product-id');
    var type = $target.data('product-type');
    $.ajax({
        url: '/api/ecom/' + type + '/' + id,
        dataType: 'json'
    }).done(function(data) {
        console.log(data);
        if (data.userCanBuy == false) {
            $target.find('[data-role="qty-selector"]').hide();
            $target.find('form button[type="submit"]').hide();
            // $target.find('[data-role="user-group-not-eligible"]').text('This product is only available to the following DSD users: ' + data.eligibleGroups).removeClass('d-none').addClass('d-inline-block');
            $target.find('[data-role="user-group-not-eligible"]').text('This product is unavailable').removeClass('d-none').addClass('d-inline-block');
            // $target.find('.ecom-mini').remove();
        }
        $.each(data.variants, function() {
            $target.find('[data-variant-price="' + this.id + '"]:not([data-qty])').text(this.salePrice);
            $target.find('.ecom-mini select[name="purchasableId"] option[value="' + this.id + '"]:not([data-qty])').text(this.salePrice + ' — ' + this.title);
            if (this.onSale) {
                $target.find('[data-variant-price="' + this.id + '"]:not([data-qty])').prepend('<span class="font-weight-light font-size-normal small"><del>' + this.price + '</del></span><br>');
            }
        });
    });
};

export default func;